import { BaseModel } from './base.model'
import { User } from './user.model'

export class NoteHistory extends BaseModel {
  id: string
  note: string | string[]
  createdAt: string
  noteType: string
  createdBy: Pick<User, 'id' | 'name' | 'fullName' | 'email'>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  vehicle?: string | any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  device?: string | any
  arrayNotes?: boolean
}
